export var CUSTOMER_INFORMATION_STEP = 1;
export var FULFILLMENT_INFORMATION_STEP = 2;
export var PAYMENT_INFORMATION_STEP = 3;